export default "__VITE_ASSET__a7e06690__"